"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AggregationType = void 0;
var AggregationType;
(function (AggregationType) {
    AggregationType[AggregationType["None"] = 0] = "None";
    AggregationType[AggregationType["Max"] = 1] = "Max";
    AggregationType[AggregationType["Min"] = 2] = "Min";
    AggregationType[AggregationType["Average"] = 3] = "Average";
    AggregationType[AggregationType["Sum"] = 4] = "Sum";
    AggregationType[AggregationType["Count"] = 5] = "Count";
})(AggregationType = exports.AggregationType || (exports.AggregationType = {}));
//# sourceMappingURL=AggregationType.js.map